import React from 'react';

function Contact() {
  return (
    <section className="section" id="contact" style={{ background: 'white' }}>
      <div className="container">
        <div className="section-header" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 56px' }}>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Get in Touch</h2>
          <p className="section-desc" style={{ textAlign: 'center', marginTop: '20px' }}>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>

        <div className="contact-grid">
          <div>
            <div style={{ marginBottom: '40px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '24px', background: 'linear-gradient(135deg, #F0F9FF, #E0F2FE)', borderRadius: '16px', marginBottom: '20px' }}>
                <div style={{ width: '48px', height: '48px', background: 'linear-gradient(135deg, #2563EB, #7C3AED)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '20px', flexShrink: 0 }}>📧</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748B', marginBottom: '4px' }}>Email Us</div>
                  <a href="mailto:admin@astravision.net" style={{ fontSize: '16px', fontWeight: '700', color: '#2563EB', textDecoration: 'none' }}>admin@astravision.net</a>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '24px', background: 'linear-gradient(135deg, #F0F9FF, #E0F2FE)', borderRadius: '16px', marginBottom: '20px' }}>
                <div style={{ width: '48px', height: '48px', background: 'linear-gradient(135deg, #10B981, #059669)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '20px', flexShrink: 0 }}>📞</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748B', marginBottom: '4px' }}>Call Us</div>
                  <a href="tel:+919741979100" style={{ fontSize: '16px', fontWeight: '700', color: '#10B981', textDecoration: 'none' }}>+91 9741979100</a>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '24px', background: 'linear-gradient(135deg, #F0F9FF, #E0F2FE)', borderRadius: '16px' }}>
                <div style={{ width: '48px', height: '48px', background: 'linear-gradient(135deg, #F59E0B, #D97706)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '20px', flexShrink: 0 }}>📍</div>
                <div>
                  <div style={{ fontSize: '14px', color: '#64748B', marginBottom: '4px' }}>Visit Us</div>
                  <div style={{ fontSize: '16px', fontWeight: '700', color: '#0F172A' }}>#16, Survey No.52/2, 11th Cross,<br />Balajinagar, Thigalarapalya Main Road,<br />Bangalore 560058</div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: 'linear-gradient(135deg, #F8FAFC, #F1F5F9)', padding: '32px', borderRadius: '20px' }}>
            <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#0F172A', marginBottom: '8px' }}>Full Name</label>
                <input type="text" placeholder="John Doe" style={{ width: '100%', padding: '14px', border: '2px solid #E2E8F0', borderRadius: '12px', fontSize: '15px', fontFamily: "'Inter', sans-serif", transition: 'border-color 0.3s' }} />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#0F172A', marginBottom: '8px' }}>Email Address</label>
                <input type="email" placeholder="you@school.edu" style={{ width: '100%', padding: '14px', border: '2px solid #E2E8F0', borderRadius: '12px', fontSize: '15px', fontFamily: "'Inter', sans-serif" }} />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#0F172A', marginBottom: '8px' }}>Message</label>
                <textarea placeholder="Tell us how we can help..." rows="4" style={{ width: '100%', padding: '14px', border: '2px solid #E2E8F0', borderRadius: '12px', fontSize: '15px', fontFamily: "'Inter', sans-serif", resize: 'vertical' }}></textarea>
              </div>

              <button type="submit" style={{ width: '100%', height: '52px', background: 'linear-gradient(135deg, #2563EB, #7C3AED)', color: 'white', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', transition: 'transform 0.3s', boxShadow: '0 8px 20px rgba(37, 99, 235, 0.4)' }}>Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
